"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
var reducers_1 = __importStar(require("./items/reducers"));
var reducers_2 = __importDefault(require("./shippingCountry/reducers"));
var reducers_3 = __importStar(require("./totals/reducers"));
var reducers_4 = __importDefault(require("./tax/reducers"));
var actions = __importStar(require("./actions"));
var actions_1 = require("../utils/actions");
exports.initialState = {
    cartId: null,
    isLoading: false,
    error: null,
    errors: null,
    currency: null,
    totalQuantity: null,
    processorDiscounts: null,
    items: null,
    checkoutItems: null,
    shippingCountry: null,
    totals: null,
    cartTotals: null,
    tax: null,
};
var cartReducer = function (state, action) {
    if (state === void 0) { state = exports.initialState; }
    var cartId = state.cartId;
    var isLoading = state.isLoading;
    var error = state.error;
    var errors = state.errors;
    var currency = state.currency;
    var totalQuantity = state.totalQuantity;
    var processorDiscounts = state.processorDiscounts;
    if ((0, actions_1.isType)(action, actions.updateCartIdAction)) {
        cartId = action.payload.cartId;
    }
    else if ((0, actions_1.isType)(action, actions.setCartLoaderAction)) {
        var isLoadingValue = action.payload.isLoading;
        isLoading = isLoadingValue;
    }
    else if ((0, actions_1.isType)(action, actions.setCartErrorAction)) {
        isLoading = false;
        error = action.payload.error;
    }
    else if ((0, actions_1.isType)(action, actions.setCartErrorsAction)) {
        isLoading = false;
        errors = action.payload.errors;
    }
    else if ((0, actions_1.isType)(action, actions.setCartCurrencyAction)) {
        currency = action.payload.currency;
    }
    else if ((0, actions_1.isType)(action, actions.setTotalQuantityAction)) {
        totalQuantity = action.payload.quantity;
    }
    else if ((0, actions_1.isType)(action, actions.setProcessorDiscountsAction)) {
        processorDiscounts = action.payload.processorDiscounts;
    }
    return __assign(__assign({}, state), { cartId: cartId, isLoading: isLoading, error: error, currency: currency, totalQuantity: totalQuantity, processorDiscounts: processorDiscounts, items: (0, reducers_1.default)(state.items, action), checkoutItems: (0, reducers_1.checkoutItemsReducer)(state.checkoutItems, action), totals: (0, reducers_3.default)(state.totals, action), cartTotals: (0, reducers_3.cartTotalsReducer)(state.cartTotals, action), shippingCountry: (0, reducers_2.default)(state.shippingCountry, action), tax: (0, reducers_4.default)(state.tax, action) });
};
exports.default = cartReducer;
